<script setup lang="ts">
  /**
   * ExploreMore — Yahoo-style rail module listing categories with emoji
   * icons. Link targets come fully-built from the hosting page; this
   * component knows nothing about the page's URL contract.
   */
  import type { ExploreMoreProps } from './types'

  withDefaults(defineProps<ExploreMoreProps>(), {
    heading: 'Explore More',
    items: () => [],
  })
</script>

<template>
  <section class="rounded-lg bg-surface-primary p-4">
    <h2 class="pb-2 text-[17px] font-bold text-content-primary">
      {{ heading }}
    </h2>

    <ul class="flex flex-col">
      <li v-for="item in items" :key="item.category">
        <NuxtLink :to="item.to" class="group flex items-center gap-3 py-2">
          <span class="w-6 text-center text-lg leading-none">
            {{ item.emoji }}
          </span>
          <span
            class="text-sm font-medium text-content-primary group-hover:underline"
          >
            {{ item.label }}
          </span>
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>
